import localforage from "localforage";

// 这里不再使用全局 config，而是根据前缀创建不同实例
export const lightningStore = localforage.createInstance({
    driver: [localforage.INDEXEDDB],
    name: "Lightning_database",
    storeName: "Lightning_Boundary_table"
});

export const climateShiftStore = localforage.createInstance({
    driver: [localforage.INDEXEDDB],
    name: "ClimateShift_database",
    storeName: "ClimateShift_table"
});

export const weevilTrakStore = localforage.createInstance({
    driver: [localforage.INDEXEDDB],
    name: "WeevilTrak_database",
    storeName: "WeevilTrak_table"
});
